export const VideoCallBackgroundEffect = Object.freeze({
  none: 'none',
  blur: 'blur',
  background: 'background',
});

export const VIDEO_CALL_EXPAND_EVENT = 'homesight:expand-video-call';
